import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'passwordRequirements',
    standalone: false
})
export class PasswordRequirementsPipe implements PipeTransform {
    transform(value: any): any {
        return `
            • 8 characters minimum
            • upper and lowercase letters
            • at least one special character
            • at least one number
        `
    }
}
